<!-- superscript area above the field -->
<div class="grit-field-superscript-container pg-field-superscript-container">
  <ng-content
    select="pg-field-superscript-container, grit-field-superscript-container"
  ></ng-content>
</div>

<!-- border around the field -->
<div class="pg-field-border" #fieldBorder>
  <!-- for components that want to render  between the border and the top  of the input -->
  <ng-content select="pg-field-top-border-gap, grit-field-top-border-gap">
  </ng-content>

  <!-- pg container defines a row flex container to place prefix, infix and suffix -->
  <div class="pg-field-container" (click)="this.control?.onContainerClick()">
    <!-- The prefix icon slot-->
    <ng-content
      select="pg-field-prefix, pg-prefix-icons, grit-field-prefix, grit-prefix-icons"
    ></ng-content>

    <!-- 
      We want the label absolutely positioned as left as it can go
      without covering the prefix, and we want to allow the label to 
      spill over the suffix to the right if it needs to.
      By adding a sub container over
      the field and the suffix we can position the label absolutely
      to the left while retaining the automatic change in position
      when the prefix appears and dissapears.
    -->
    <div class="pg-field-label-container">
      <!-- label lives absolutely positioned and managed by the pg-field class -->
      <ng-content select="[pgLabel],[gritLabel]"></ng-content>
      <!-- 
      the main form control slot
      container provides flex layout and 
      relative position
    -->
      <div class="pg-field-control-container"><ng-content></ng-content></div>

      <!-- The suffix icon slot -->
      <ng-content
        select="pg-field-suffix, pg-suffix-icons, grit-field-suffix, grit-suffix-icons"
      ></ng-content>
    </div>
  </div>

  <!-- for components that want to render between the border and the bottom of the input -->
  <ng-content select="pg-field-bottom-border-gap, grit-field-bottom-border-gap">
  </ng-content>
</div>

<!-- Subscript lives outside of the border -->
<div class="pg-field-subscript-container">
  <ng-content
    select="pg-field-subscript, pg-subscript-messages, grit-field-subscript, grit-subscript-messages"
  ></ng-content>
</div>
